export const mainDivStyle = {
    display: "flex", 
    flexFlow: "column",
    maxWidth: "1200px", 
    backgroundImage: "url(./img/backgroundSite.png)", 
    backgroundRepeat: "repeat",
    padding: "25px",
    justifyContent: "center"
}

export const mainDivMobileStyle = {
    display: "flex", 
    flexFlow: "column",
    backgroundImage: "url(./img/backgroundSite.png)", 
    backgroundRepeat: "repeat",
    padding: "25px",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    fontSize:"medium"
}

export const rowStyle ={
    display: "flex",
    textAlign: "justify",
    marging:"10px"
}

export const columnStyle ={
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    textAlign: "justify",
    padding:"10px",
    flexDirection: "column"
}

export const cardsStyle ={
    justifyContent:"flex-start",
    color:"white",
    backgroundColor: "#8fa464",
    margin: "5px",
    borderRadius: "12px"

}

export const imgRoundedStyle = { 
    width: '150px', 
    height: '150px', 
    objectFit: 'cover',
    marginBottom: "10px"
}
